var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-3"},[_c('h4',{staticClass:"text-cranberry mb-0 notranslate",attrs:{"translate":"no"}},[_vm._v(_vm._s(_vm.rotulo))]),_c('h3',{staticClass:"notranslate",attrs:{"translate":"no"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }